import React, { useState } from "react";
import styled from "styled-components";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";

import { useTranslation } from "react-i18next";
import i18next from "i18next";

export default function Navbar() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [language, setLanguage] = useState(2);
  const html = document.querySelector("html");
  html.addEventListener("click", (e) => {
    setIsNavOpen(false);
  });

  const { t } = useTranslation();

  const changeLanguage = (lang) => {
    i18next.changeLanguage(lang);
  };

  return (
    <div className="navbar-fluid">
      <Nav className="container" state={isNavOpen ? 1 : 0}>
        <div className="brand">
          <svg
            width="210"
            height="43"
            viewBox="0 0 210 43"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_4_15)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M486 -4H-7V104H486V-4ZM-3.04348 44.4901V32.7822V-1.27723H105.435H211.522V32.7822V44.4901H105.435H-3.04348ZM108.043 16.6891C108 12.4743 103.609 8.7703 97.3044 7.70595C93.3478 7.02476 88.2174 6.85446 83.4783 7.23763C74 8.00396 69.7826 10.7287 69.7826 16.1782C69.7826 22.1386 73.8696 24.6931 84.9565 25.5871C99.8696 26.7366 100.826 26.9495 101.217 28.7802C101.783 31.8456 99.4348 32.697 90.3478 32.7396C81.087 32.7822 77.4783 31.8455 77.0869 29.2485C76.9565 28.3545 76.7391 28.3119 72.9565 28.1842L68.913 28.0564V29.504C68.913 33.9317 72.5652 37.2525 78.8696 38.5723C82.913 39.3812 95.7391 39.3812 100.13 38.4871C106.739 37.2099 109.565 34.2297 109.261 28.8653C109.13 26.8218 108.826 25.6723 108.217 24.8208C106.174 22.1386 101.522 20.7337 93.0435 20.2228C85.913 19.8396 80.2174 19.201 79.3043 18.7327C77.1739 17.5832 77.4348 14.901 79.7826 14.1346C81.913 13.3683 89.2609 13.0703 93.1304 13.5812C97.4783 14.1347 99.087 14.8584 99.6957 16.604L100.174 17.8812H104.087H108.043V16.6891ZM13.6957 38.7426L13.6087 23.0752L13.4783 7.4505L9.78261 7.32277C7.73913 7.23762 5.91304 7.32278 5.73913 7.49307C5.56522 7.66337 5.43478 14.7733 5.43478 23.2881V38.7426H9.56522H13.6957ZM42.913 19.1158C37.1304 12.8574 32.087 7.66337 31.6957 7.49307C30.7826 7.15248 21.7391 7.15247 21.3913 7.53564C21.2174 7.66336 21.087 14.7733 21.087 23.2881V38.7426H25.2174H29.3478L29.4348 27.1624L29.5652 15.5822L37.3913 24.0545C41.6957 28.6951 46.4783 33.8891 48.0435 35.6346L50.8261 38.7426H56.6087H62.3913L62.3043 23.0752L62.1739 7.4505L58.1739 7.32277L54.1304 7.19505V18.9455C54.1304 25.4168 53.9565 30.6535 53.7826 30.5683C53.5652 30.4832 48.6956 25.3317 42.913 19.1158ZM151.096 27.9647C149.109 24.223 146.641 19.5744 144.826 16.0505L140.174 7.23763H134.783H129.391L123 19.4564C119.522 26.2257 115.783 33.2931 114.739 35.2089L112.826 38.7426H117.304H121.783L128.174 26.1832C131.696 19.2861 134.652 13.6238 134.826 13.6238C134.957 13.6238 137.87 19.2861 141.348 26.1832L147.696 38.7426H152.261H156.783L153.13 31.803C152.57 30.741 151.869 29.4216 151.096 27.9647ZM184.206 18.8557C181.071 15.4404 178.115 12.2205 176.87 10.8139L173.696 7.32277L168.261 7.2802L162.826 7.19505V22.9901V38.7426H166.739H170.652V27.205C170.652 20.2228 170.826 15.7525 171.043 15.8376C171.261 15.8802 176.174 21.0743 181.957 27.3327L192.478 38.7426H198.087H203.696V22.9901V7.19505L199.696 7.32277L195.652 7.4505L195.435 19.1158L195.217 30.8238L187.609 22.5644C186.499 21.3537 185.341 20.0919 184.206 18.8557ZM129.913 35.1663C130 35.2941 132.261 35.2941 134.913 35.2515L139.739 35.1238L137.174 30.0149L134.652 24.9059L132.174 29.9297C130.826 32.697 129.783 35.0386 129.913 35.1663Z"
              />
            </g>
            <defs>
              <clipPath id="clip0_4_15">
                <rect width="210" height="43" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <div className={`links ${isNavOpen ? "show" : ""}`}>
          <ul>
            <li>
              <a href="#about">{t("bizhaqimizda")}</a>
            </li>
            <li>
              <a href="#services">{t("xizmatlar")}</a>
            </li>
            <li>
              <a href="#portfolio">{t("portfolio")}</a>
            </li>
            <li>
              <a href="#testimonials">{t("mijozlar-fikri")}</a>
            </li>
            <li>
              <a href="#call">{t("aloqa")}</a>
            </li>
          </ul>
        </div>

        <div className="nav-end">
          <div className="language">
            <span
              onClick={() => {
                setLanguage(1);
                changeLanguage("ru");
              }}
              className={language === 1 ? "active" : ""}
            >
              RU
            </span>

            <span
              onClick={() => {
                setLanguage(2);
                changeLanguage("uz");
              }}
              className={language === 2 ? "active" : ""}
            >
              UZ
            </span>
          </div>

          <a className="button" href="#call">
            {t("boglanish")}
          </a>
        </div>

        <div className="toggle">
          {isNavOpen ? (
            <MdClose
              onClick={() => {
                setIsNavOpen(false);
              }}
            />
          ) : (
            <GiHamburgerMenu
              onClick={(e) => {
                e.stopPropagation();
                setIsNavOpen(true);
              }}
            />
          )}
        </div>
      </Nav>
    </div>
  );
}

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding-block: 25px;

  @media (min-width: 1600px) and (max-width: 2100px) {
    margin-top: -20px;
  }
  @media (max-width: 992px) {
    padding-top: 20px !important;
    padding-bottom: 10px !important;
  }

  .brand {
    svg {
      width: 210px;
      height: 43px;
      background-size: cover;
      background-position: center;
      fill: #00094c;
      transition: all 0.3s;

      &:hover {
        fill: #0041ff;
        cursor: pointer;
        animation: anim 2s linear 1;
      }
      @keyframes anim {
        0% {
          width: 210px;
          fill: #909fe6;
        }
        100% {
          width: 210px;
        }
      }
    }
  }

  .toggle {
    display: none;
  }

  .links {
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;

    ul {
      display: flex;
      list-style-type: none;
      li {
        a {
          margin: 20px;
          font-size: 20px;
          color: #00094c !important;
          text-decoration: none;
          transition: background-size 350ms;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 20px;
            top: 30px;
            margin: 0 auto;
            transition: all 0.4s;
            left: 40%;
            border-bottom: 4px dotted transparent;
          }

          &:hover {
            &::after {
              content: "";
              position: absolute;
              width: 20px;
              top: 30px;
              margin: 0 auto;
              left: 40%;
              border-bottom: 4px dotted #0041ff;
            }
          }
        }
      }
    }
  }

  .nav-end {
    display: flex;
    align-items: center;
    a {
      @media (max-width: 992px) {
        display: none;
      }
    }
    .language {
      display: flex;
      flex-direction: row;
      margin: 0 20px;
      position: relative;

      span {
        display: inline-block;
        padding: 0 10px;
        font-size: 20px;
        font-weight: 500;
        color: #9b9b9b;
        cursor: pointer;
      }

      .active {
        color: #00094c;
      }

      span:first-child {
        border-right: 2px solid #d9d9d9;
      }
    }
  }

  @media (max-width: 1430px) {
    .brand {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 120px;

      svg {
        width: 120px;
        height: 25px;
        &:hover {
          fill: #0041ff;
          cursor: pointer;
          animation: anim 2s linear 1;
        }
        @keyframes anim {
          0% {
            width: 120px;
          }
          100% {
            width: 120px;
          }
        }
      }
    }

    .show {
      opacity: 1 !important;
      visibility: visible !important;
      overflow: hidden;
    }

    .links {
      height: 4rem;
      display: flex;
      justify-content: center;
      align-items: center;

      ul {
        display: flex;
        list-style-type: none;
        li {
          a {
            margin: 20px;
            font-size: 18px;
            color: #111111;
            text-decoration: none;
            background: linear-gradient(0deg, #848192, #6a6876) no-repeat right
              bottom / 0 var(--bg-h) !important;
            transition: background-size 350ms;
            --bg-h: 100%;
            text-decoration: none;
            color: inherit;
            line-height: 1;
            padding-bottom: 2px;
            --bg-h: 2px;

            &:where(:hover, :focus-visible) {
              background-size: 100% var(--bg-h);
              background-position-x: left;
            }
          }
        }
      }
    }

    .nav-end {
      align-items: center;
      vertical-align: middle;

      .language {
        span {
          font-size: 16px;
        }
      }
    }
  }

  @media (max-width: 1180px) {
    position: relative;
    padding: 10px 30px;
    z-index: 999;
    align-items: center;
    margin: 0;
    button {
      display: none;
    }

    .brand {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      z-index: 99;

      img {
        width: 120px;
        height: 40px;
      }
    }

    .toggle {
      display: block;
      transform: translateY(3px);
      z-index: 51;
      font-size: 22px;
      svg {
        color: black;
      }
    }

    .show {
      opacity: 1 !important;
      visibility: visible !important;
      overflow: hidden;
    }

    .links {
      z-index: 50;
      position: absolute;
      overflow-x: hidden;
      top: 0% !important;
      right: 0;
      width: 100%;
      height: ${({ state }) => (state ? "100vh" : "0")};
      border-bottom: 2px solid blue;
      background-color: #d9e9ff;
      overflow: hidden;
      opacity: 0;
      top: 60px;
      visibility: hidden;
      transition: 0.4s ease-in-out;
      clip-path: none;

      ul {
        flex-direction: column;
        text-align: center;
        height: 100%;
        padding: 0;
        justify-content: center;

        li {
          a {
            color: black;
            border-bottom: 2px solid transparent;
            line-height: 60px;
            font-size: 24px;
          }
        }
      }
    }

    .nav-end {
      flex-direction: row-reverse !important;
      align-items: center;
      vertical-align: middle;

      .language {
        span {
          font-size: 20px;
        }
      }
    }
  }

  @media (max-width: 600px) {
    padding: 10px 20px;

    .brand {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      img {
        width: 100px;
        height: 20px;
      }
    }
  }
`;
